import { SignInComponent } from './signin.component';

export const SIGNIN_COMPONENTS: any[] = [
  SignInComponent,
];



// WEBPACK FOOTER //
// ./src/app/components/signin/index.ts